import { useState,useEffect } from "react";
import { toast } from "react-toastify";
import { linkSpotifyAdAccount } from "../../../../services/ApiService";

import { useNavigate } from "react-router-dom";

export const SpotifyAdsAccountTable = ({
    setShowAdAccountsModal,
    adAccounts,
    setAdAccounts,
    fetchAdsAccountStatus
    
}) => {
    const [linking, setlinking] = useState(false);
    const navigate=useNavigate()
    const headers = [
        { label: "Sl.No", key: "sl.no" },
        { label: "Account Name", key: "name" },
        { label: "Type", key: "type" },
        { label: "Actions", key: "actions" },
    ];

    const handleConnect = async (ad_accounts_id, index) => {
        setlinking((prev) => ({ ...prev, [index]: true })); // Set loading for the specific button
        try {
          
            const response = await linkSpotifyAdAccount(ad_accounts_id);
           
            if (response?.success) {
                toast.success(response?.message);
                setShowAdAccountsModal(false)
                fetchAdsAccountStatus()
                
                
           
    } else {
                toast.error("Error connecting Spotify Ads Account");
            }
        } catch (error) {
            console.log(error)
            toast.error("Error connecting Spotify Ads Account");
        } finally {
            setlinking((prev) => ({ ...prev, [index]: false })); // Stop loading
            navigate('/client/settings/integrations')
        }
    };
    useEffect(() => {
       
        
    }, []);
    

    return (
        <div className="card-lg bg-light">
            <div className="table-responsive text-nowrap card-body py-0">
                <table className="table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4 table-auto m-0">
                    <thead>
                        <tr className="fw-bold text-muted bg-light ">
                            {headers.map((header) => (
                                <th className={`min-w-100px ${header.label==='Actions'&&'text-end'}`} key={header.key}>
                                    {header.label}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {adAccounts?.length === 0 ? (
                            <tr>
                                <td colSpan={headers.length} className="text-center text-muted">
                                    No data available
                                </td>
                            </tr>
                        ) : (
                            adAccounts?.map((adAccount, index) => (
                                <tr className="text-muted" key={index}>
                                    <td>{index + 1}</td>
                                    <td>{adAccount?.name || "---"}</td>
                                    <td>{adAccount?.type || "---"}</td>
                                    <td className="d-flex justify-content-end">
                                        <button
                                            className="btn btn-sm rounded-pill btn-primary d-flex align-items-center justify-content-center"
                                            style={{ width: "150px" }}
                                            onClick={() => handleConnect(adAccount?.id, index)}
                                            disabled={linking[index]} // Disable button while loading
                                        >
                                            {linking[index] ? (
                                                <span>Please Wait...</span>
                                            ) : (
                                                <span>Connect Account</span>
                                            )}
                                        </button>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};
